import { render, staticRenderFns } from "./Poi.vue?vue&type=template&id=74b4be56&"
import script from "./Poi.vue?vue&type=script&lang=js&"
export * from "./Poi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports